// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"bd92b284","774":"c450a9b9","787":"2679092b"}[chunkId] + ".chunk.js";
};